/*
 * Copyright Amazon.com, Inc. and its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: MIT
 *
 * Licensed under the MIT License. See the LICENSE accompanying this file
 * for the specific language governing permissions and limitations under
 * the License.
 */

import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { setAuth, setUser } from "../../redux/actions";
import { useAuthenticator } from "@aws-amplify/ui-react";

import checkForceAuth from "../../helpers/checkForceAuth";
import handleAuthUIStateChange from "../../helpers/handleAuthStateChange";
import handleIdpLogin from "../../helpers/handleIdpLogin";

function Loading() {
	return (
		<div className="o-page-loader">
			<div className="o-page-loader--content">
				<div className="o-page-loader--spinner"></div>
				<div className="o-page-loader--message"></div>
			</div>
		</div>
	);
}

const mapStateToProps = (state) => {
	return {
		lang: state.app.lang,
	};
};

const LandingPage = (props) => {
	const { authStatus } = useAuthenticator((context) => [context.authStatus]);

	checkForceAuth();

	handleIdpLogin.bind(this);
	handleAuthUIStateChange(authStatus, props.siteKey, props.lang);

	return <Loading />;
};

export default withRouter(
	connect(mapStateToProps, { setAuth, setUser })(LandingPage)
);
